import { useSegmentConfigStore } from 'stores/segmentConfigStore';

/**
 * Returns the segmentation settings for a specific customer
 * @param customerLegalName
 */
export function useSegmentConfig(customerLegalName?: string) {
  const { config, isLoaded } = useSegmentConfigStore();

  if (!isLoaded || !customerLegalName || !config) return null;

  return config[customerLegalName.toUpperCase()] || null;
}
